'use strict';

function _decDegFromMatch(m) {
  const signIndex = {
    '-': -1,
    'N': 1,
    'S': -1,
    'E': 1,
    'W': -1
  };

  const latLonIndex = {
    N: 'lat',
    S: 'lat',
    E: 'lon',
    W: 'lon'
  };

  const sign = signIndex[m[2]] || signIndex[m[1]] || signIndex[m[6]] || 1;
  const degrees = Number(m[3]);
  const minutes = m[4] ? Number(m[4]) : 0;
  const seconds = m[5] ? Number(m[5]) : 0;
  const latLon = latLonIndex[m[1]] || latLonIndex[m[6]];

  if (!_inRange(degrees, 0, 180)) {
    throw new Error('Degrees out of range');
  }
  if (!_inRange(minutes, 0, 60)) {
    throw new Error('Minutes out of range');
  }
  if (!_inRange(seconds, 0, 60)) {
    throw new Error('Seconds out of range');
  }

  return {
    decDeg: sign * (degrees + minutes / 60 + seconds / 3600),
    latLon
  };
}
function _inRange(value, a, b) {
  return value >= a && value <= b;
}

export default function parseDms(dmsString) {
  dmsString = dmsString.trim();

  // Inspired by https://gist.github.com/JeffJacobson/2955437
  // See https://regex101.com/r/kS2zR1/3
  const dmsRe = /([NSEW])?(-)?(\d+(?:\.\d+)?)[°º:d\s]?\s?(?:(\d+(?:\.\d+)?)['’‘′:]\s?(?:(\d{1,2}(?:\.\d+)?)(?:"|″|’’|'')?)?)?\s?([NSEW])?/i;

  const result = {};

  const m1 = dmsString.match(dmsRe);

  if (!m1) {
    throw new Error('Could not parse string');
  }

  let dmsString2 = '';
  // If dmsString starts with a hemisphere letter, then the regex can also capture the
  // hemisphere letter for the second coordinate pair if also in the string
  if (m1[1]) {
    m1[6] = undefined;
    dmsString2 = dmsString.substr(m1[0].length - 1).trim();
  } else {
    dmsString2 = dmsString.substr(m1[0].length).trim();
  }

  const decDeg1 = _decDegFromMatch(m1);

  const m2 = dmsString2.match(dmsRe);

  const decDeg2: any = m2 ? _decDegFromMatch(m2) : {};

  if (typeof decDeg1.latLon === 'undefined') {
    if (!isNaN(decDeg1.decDeg) && isNaN(decDeg2.decDeg)) {
      // If we only have one coordinate but we have no hemisphere value,
      // just return the decDeg number
      return decDeg1.decDeg;
    } else if (!isNaN(decDeg1.decDeg) && !isNaN(decDeg2.decDeg)) {
      // If no hemisphere letter but we have two coordinates,
      // infer that the first is lat, the second lon
      decDeg1.latLon = 'lat';
      decDeg2.latLon = 'lon';
    } else {
      throw new Error('Could not parse string');
    }
  }

  // If we parsed the first coordinate as lat or lon, then assume the second is the other
  if (typeof decDeg2.latLon === 'undefined') {
    decDeg2.latLon = decDeg1.latLon === 'lat' ? 'lon' : 'lat';
  }

  result[decDeg1.latLon] = decDeg1.decDeg;
  result[decDeg2.latLon] = decDeg2.decDeg;

  return result;
}
